import React from "react";
import "./OrientationGuard.css";
import { usePortraitOrientationGuard } from "./usePortraitOrientationGuard";

function RotatePhoneIllustration({ targetOrientation }) {
  const shouldPointToLandscape = targetOrientation === "landscape";
  return (
    <svg
      className="orientation-guard__illustration"
      viewBox="0 0 360 260"
      role="img"
      aria-label="چرخاندن گوشی به حالت عمودی"
    >
      <g className="orientation-guard__phone orientation-guard__phone--landscape">
        <rect x="104" y="107" width="190" height="112" rx="22" />
        <rect
          className="orientation-guard__island"
          x="278"
          y="145"
          width="8"
          height="36"
          rx="4"
        />
        <path className="orientation-guard__home-indicator" d="M188 211h24" />
      </g>

      <g className="orientation-guard__phone orientation-guard__phone--portrait">
        <rect x="72" y="34" width="112" height="200" rx="24" />
        <rect
          className="orientation-guard__island"
          x="112"
          y="44"
          width="32"
          height="8"
          rx="4"
        />
        <path className="orientation-guard__home-indicator" d="M116 225h24" />
      </g>

      <path
        className="orientation-guard__arrow"
        d={
          shouldPointToLandscape
            ? "M198 27c38 -20 85 24 78 54"
            : "M286 91c-10-40-40-63-78-64"
        }
      />
      <path
        className="orientation-guard__arrow-head"
        d={
          shouldPointToLandscape
            ? "m262 66 15 20 9-24"
            : "m215 12-21 15 22 13"
        }
      />
    </svg>
  );
}

function OrientationGuard({ children }) {
  const guardTarget = usePortraitOrientationGuard();
  const shouldShowGuard = Boolean(guardTarget);

  return (
    <>
      {children}

      {shouldShowGuard && (
        <div
          className="orientation-guard"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="orientation-guard__content">
            <RotatePhoneIllustration targetOrientation={guardTarget} />

            <p className="orientation-guard__message">
              {guardTarget === "landscape"
                ? "لطفاً دستگاه خود را افقی نگه دارید."
                : "لطفاً دستگاه خود را عمودی نگه دارید."}
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default OrientationGuard;
